import Dragger from './Dragger';
import UploadCard from './Card';
import InternalUpload, { LIST_IGNORE } from './Upload';
export { DraggerProps } from './Dragger';
export { RcFile, UploadChangeParam, UploadFile, UploadListProps, UploadProps } from './interface';
const Upload = InternalUpload;
Upload.Dragger = Dragger;
Upload.LIST_IGNORE = LIST_IGNORE;
Upload.MSB = UploadCard;
export default Upload;
